import { render, staticRenderFns } from "./RecurringSMSCampaignsListRoute.vue?vue&type=template&id=5372426e&scoped=true&"
import script from "./RecurringSMSCampaignsListRoute.vue?vue&type=script&lang=js&"
export * from "./RecurringSMSCampaignsListRoute.vue?vue&type=script&lang=js&"
import style0 from "./RecurringSMSCampaignsListRoute.vue?vue&type=style&index=0&id=5372426e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5372426e",
  null
  
)

export default component.exports